import { NgModule } from '@angular/core';
import { CommonModule } from '../common/common.module';
import { CoreModule } from './../core/core.module';
import { InvoiceModule } from './../invoice/invoice.module';
import { ArticleService } from './service/data/article.service';
import { BuildingService } from './service/data/building.service';
import { ColumnDefinitionService } from './service/data/column-definition.service';
import { CompanyService } from './service/data/company.service';
import { DwellingContractService } from './service/data/dwelling-contract.service';
import { DwellingService } from './service/data/dwelling.service';
import { OtherContractService } from './service/data/other-contract.service';
import { OtherRentalObjectService } from './service/data/other-rental-object.service';
import { ParkingContractService } from './service/data/parking-contract.service';
import { ParkingService } from './service/data/parking.service';
import { PremisesContractService } from './service/data/premises-contract.service';
import { PremisesService } from './service/data/premises.service';
import { PropertyService } from './service/data/property.service';
import { RentalObjectTypeService } from './service/data/rental-object-type.service';
import { ContactService } from './service/data/contact.service';
import { CompanyManagerComponent } from './component/company-manager/company-manager.component';
import { CompanySystemSettingsBulkComponent } from './component/company-system-settings-bulk/company-system-settings-bulk.component';
import { RentalObjectTypeManagerComponent } from './component/object-manager/object-manager.component';
import { ArticleAutocompleteComponent } from './component/article-autocomplete/article-autocomplete.component';
import { TenantAutocompleteComponent } from './component/tenant-autocomplete/tenant-autocomplete.component';
import { LeaseRowsComponent } from './component/lease-rows/lease-rows.component';
import { LeaseRowFormComponent } from './component/lease-row-form/lease-row-form.component';
import { ArticleFormComponent } from './component/article-form/article-form.component';
import { BuildingFormComponent } from './component/building-form/building-form.component';
import { CompanyFormComponent } from './component/company-form/company-form.component';
import { DwellingFormComponent } from './component/dwelling-form/dwelling-form.component';
import { PropertyFormComponent } from './component/property-form/property-form.component';
import { PropertyErrandTagResponsibilityComponent } from './component/property-errand-tag-responsibility/property-errand-tag-responsibility.component';
import { DwellingContractFormComponent } from './component/dwelling-contract-form/dwelling-contract-form.component';
import { DwellingRentalObjectManagerComponent } from './component/dwelling-rental-object-manager/dwelling-rental-object-manager.component';
import { OtherRentalObjectFormComponent } from './component/other-rental-object-form/other-rental-object-form.component';
import { ContactFormComponent } from './component/contact-form/contact-form.component';
import { RentalObjectTypeFormComponent } from './component/rental-object-type-form/rental-object-type-form.component';
import { ParkingFormComponent } from './component/parking-form/parking-form.component';
import { PremisesFormComponent } from './component/premises-form/premises-form.component';
import { ParkingContractFormComponent } from './component/parking-contract-form/parking-contract-form.component';
import { PremisesContractFormComponent } from './component/premises-contract-form/premises-contract-form.component';
import { OtherContractFormComponent } from './component/other-contract-form/other-contract-form.component';
import { VacantPeriodAutocompleteComponent } from './component/vacant-period-autocomplete/vacant-period-autocomplete.component';
import { VacantPeriodCooperativeHousingAutocompleteComponent } from './component/vacant-period-cooperative-housing-autocomplete/vacant-period-cooperative-housing-autocomplete.component';
import { VacantDwellingComponent } from './component/vacant-dwelling/vacant-dwelling.component';
import { VacantParkingComponent } from './component/vacant-parking/vacant-parking.component';
import { VacantPremisesComponent } from './component/vacant-premises/vacant-premises.component';
import { VacantOtherRentalObjectComponent } from './component/vacant-other-rental-object/vacant-other-rental-object.component';
import { NoticePeriodComponent } from './component/notice-period/notice-period.component';
import { SendRegistrationKeyFormComponent } from './component/send-registration-key-form/send-registration-key-form.component';
import { NegotiationComponent } from './component/negotiation/negotiation.component';
import { CleanupTenantCommandHandler } from './service/command/cleanup-tenant-command-handler.service';
import { CreateInvoiceCommandHandler } from './service/command/create-invoice-command-handler.service';
import { PrintContractTerminationFormCommandHandler } from './service/command/print-contract-termination-form-command-handler';
import { LeaseAgreementService } from './service/data/lease-agreement.service';
import { ShowInvoicesCommandHandler } from './service/command/show-invoices-command-handler.service';
import { ShowFaultNotificationCommandHandler } from './service/command/show-fault-notification-command-handler.service';
import { RentalChangesComponent } from './component/rental-changes/rental-changes.component';
import { PrintParkingContractFormCommandHandler } from './service/command/print-parkingcontract-command-handler';
import { TenantService } from './service/data/tenant.service';
import { VacantRentalObjectService } from './service/data/vacant-period.service';
import { ContractInvoicingComponent } from './component/contract-invoicing/contract-invoicing.component';
import { BankAccountComponent } from './component/bank-account/bank-account.component';
import { LeaseAgreementExportCommandHandler } from './service/command/lease-agreement-export-command-handler.service';
import { DwellingContractManagerComponent } from './component/dwelling-contract-manager/dwelling-contract-manager.component';
import { ParkingContractManagerComponent } from './component/parking-contract-manager/parking-contract-manager.component';
import { PremisesContractManagerComponent } from './component/premises-contract-manager/premises-contract-manager.component';
import { OtherContractManagerComponent } from './component/other-contract-manager/other-contract-manager.component';
import { ContactManagerComponent } from './component/contact-manager/contact-manager.component';
import { AccountPlanService } from '../accounting/service/data/account-plan.service';
import { DwellingExportCommandHandler } from './service/command/dwelling-export-command-handler.service';
import { ParkingRentalObjectManagerComponent } from './component/parking-rental-object-manager/parking-rental-object-manager.component';
import { ParkingExportCommandHandler } from './service/command/parking-export-command-handler.service';
import { ArticleMultiSelectManagerComponent } from './component/article-manager/article-manager.component';
import { ArticleExportCommandHandler } from './service/command/article-export-command-handler.service';
import { LeaseAgreementDocumentManagerComponent } from './component/lease-agreement-document-manager/lease-agreement-document-manager.component';
import { LeaseAgreementDocumentFormComponent } from './component/lease-agreement-document-form/lease-agreement-document-form.component';
import { LinkLeaseAgreementDocumentCommandHandler } from './service/command/link-lease-agreement-document-command-handler.service';
import { LeaseAgreementDocumentService } from './service/data/lease-agreement-document.service';
import { ShowDocumentsCommandHandler } from './service/command/show-documents-command-handler.service';
import { MoveToCompanyCommandHandler } from './service/command/move-to-company-command-handler.service';
import { RentalObjectImprovementsComponent } from './component/rental-object-improvements/rental-object-improvements.component';
import { RentalObjectImprovemntsFormComponent } from './component/rental-object-improvements-form/rental-object-improvements-form.component';
import { ContractSecurityComponent } from './component/contract-security/contract-security.component';
import { SubleaseRequestsComponent } from './component/sublease-requests/sublease-requests.component';
import { SubleaseRequestFormComponent } from './component/sublease-request-form/sublease-request-form.component';
import { FormCasesFastighetsagarnaDokumentComponent } from './component/form-cases-fastighetsagarna-dokument/form-cases-fastighetsagarna-dokument.component';
import { PremisesRentalObjectManagerComponent } from './component/premises-rental-object-manager/premises-rental-object-manager.component';
import { PremisesExportCommandHandler } from './service/command/premises-export-command-handler.service';
import { RentApplicationFormComponent } from './component/rent-application-form/rent-application-form.component';
import { RentApplicationManagerComponent } from './component/rent-application-manager/rent-application-manager.component';
import { RentApplicationService } from './service/data/rent-application.service';
import { RentApplicationExportCommandHandler } from './service/command/rent-application-export-command-handler.service';
import { CompanyFortnoxConfigComponent } from './component/company-fortnox-config/company-fortnox-config.component';
import { LeaseAgreementRentPeriodManagerComponent } from './component/lease-agreement-rent-period-manager/lease-agreement-rent-period-manager.component';
import { CustomPropertyManagerComponent } from './component/custom-property-manager/custom-property-manager.component';
import { CustomPropertyFormComponent } from './component/custom-property-form/custom-property-form.component';
import { CustomPropertyService } from './service/data/custom-property.service';
import { ObjectComponentService } from './service/data/object-component.service';
import { ObjectComponentTypeService } from './service/data/object-component-type.service';
import { ObjectComponentCategoryService } from './service/data/object-component-category.service';
import { OverviewModule } from '../overview/overview.module';
import { PropertyManagerComponent } from './component/property-manager/property-manager.component';
import { ObjectComponentCategoryFormComponent } from './component/object-component-category-form/object-component-category-form.component';
import { ObjectComponentCategoryManagerComponent } from './component/object-component-category-manager/object-component-category-manager.component';
import { EntranceService } from './service/data/entrance.service';
import { BuildingManagerComponent } from './component/building-manager/building-manager.component';
import { VacantDwellingService } from './service/data/vacant-dwelling.service';
import { VacantPeriodDwellingManagerComponent } from './component/vacant-period-dwelling-manager/vacant-period-dwelling-manager.component';
import { VacantParkingService } from './service/data/vacant-parking.service';
import { VacantPeriodParkingManagerComponent } from './component/vacant-period-parking-manager/vacant-period-parking-manager.component';
import { RoomsComponent } from './component/rooms/rooms.component';
import { ObjectComponentComponent } from './component/object-component/object-component.component';
import { ObjectComponentPropertiesComponent } from './component/object-component-property/object-component-property.component';
import { RoomFormComponent } from './component/room-form/room-form.component';
import { KeyTypeService } from './service/data/key-type.service';
import { KeyTypeManagerComponent } from './component/key-type-manager/key-type-manager.component';
import { KeyTypeFormComponent } from './component/key-type-form/key-type-form.component';
import { RentalObjectKeysComponent } from './component/rental-object-keys/rental-object-keys.component';
import { VacantDwellingExportCommandHandler } from './service/command/vacant-dwelling-export-command-handler.service';
import { TerminateLeaseAgreementComponent } from './component/terminate-lease-agreement/terminate-lease-agreement.component';
import { VacantPeriodPremisesManagerComponent } from './component/vacant-period-premises-manager/vacant-period-premises-manager.component';
import { VacantPremisesService } from './service/data/vacant-premises.service';
import { VacantPremisesExportCommandHandler } from './service/command/vacant-premises-export-command-handler.service';
import { VacantParkingExportCommandHandler } from './service/command/vacant-parking-export-command-handler.service';
import { VoidCooperativeHousingLeaseAgreementComponent } from './component/void-cooperative-housing-lease-agreement/void-cooperative-housing-lease-agreement.component';
import { VoidLeaseAgreementComponent } from './component/void-lease-agreement/void-lease-agreement.component';
import { RepayBalanceFormComponent } from './component/repay-balance-form/repay-balance-form.component';
import { RepayBalanceCommandHandler } from './service/command/repay-balance-command-handler.service';
import { EsignatureErrandManagerComponent } from './component/esignature-errand-manager/esignature-errand-manager.component';
import { EsignatureErrandService } from './service/data/esignature-errand.service';
import { ESignatureErrandFormComponent } from './component/esignature-errand-form/esignature-errand-form.component';
import { ESignLeaseAgreementDocumentComponent } from './component/esign-lease-agreemeent-document/esign-lease-agreement-document.component';
import { OpenESignatureDocumentCommandHandler } from './service/command/open-esignature-document-command-handler.service';
import { AppendixService } from './service/data/appendix.service';
import { AppendixFormComponent } from './component/appendix-form/appendix-form.component';
import { AppendixManagerComponent } from './component/appendix-manager/appendix-manager.component';
import { IndexClauseSettingsFormComponent } from './component/index-clause-settings-form/index-clause-settings-form.component';
import { IndexClauseSettingsManagerComponent } from './component/index-clause-settings-manager/index-clause-settings-manager.component';
import { IndexClauseSettingsService } from './service/data/index-clause-settings.service';
import { CancelESignErrandCommandHandler } from './service/command/cancel-esign-errand-command-handler.service';
import { ArticleGroupFormComponent } from './component/article-group-form/article-group-form.component';
import { ArticleGroupMultiSelectManagerComponent } from './component/article-group-manager/article-group-manager.component';
import { ArticleGroupService } from './service/data/article-group.service';
import { ShowRentalObjectInvoicesCommandHandler } from './service/command/show-rental-object-invoices-command-handler';
import { RentalObjectDocumentFormComponent } from './component/rental-object-document-form/rental-object-document-form.component';
import { BrokerInformationFormComponent } from './component/broker-information-form/broker-information-form.component';
import { RentalObjectDocumentService } from './service/data/rental-object-document.service';
import { LinkRentalObjectDocumentCommandHandler } from './service/command/link-rental-object-document-command-handler.service';
import { RentalObjectDocumentManagerComponent } from './component/rental-object-document-manager/rental-object-document-manager.component';
import { ShowRentalObjectDocumentsCommandHandler } from './service/command/show-rental-object-documents-command-handler.service';
import { BlockContractFormComponent } from './component/block-contract-form/block-contract-form.component';
import { BlockContractManagerComponent } from './component/block-contract-manager/block-contract-manager.component';
import { BlockContractService } from './service/data/block-contract.service';
import { BlockLeaseRowsComponent } from './component/block-lease-rows/block-lease-rows.component';
import { CreateBlockContractRentalObjectCommandHandler } from './service/command/create-blockcontract-rental-object-command-handler.service';
import { ConsumptionModule } from '../consumption/consumption.module';
import { RoomService } from './service/data/room.service';
import { BuildingDocumentManagerComponent } from './component/building-document-manager/building-document-manager.component';
import { BuildingDocumentFormComponent } from './component/building-document-form/building-document-form.component';
import { ShowBuildingDocumentsCommandHandler } from './service/command/show-building-documents-command-handler.service';
import { LinkBuildingDocumentCommandHandler } from './service/command/link-building-document-command-handler.service';
import { BuildingDocumentService } from './service/data/building-document.service';
import { FaultNotificationService } from '../fault-notification/service/data/fault-notification.service';
import { VacantPeriodOtherManagerComponent } from './component/vacant-period-other-manager/vacant-period-other-manager.component';
import { VacantOtherService } from './service/data/vacant-other.service';
import { AdvertiseRentalObjectCommandHandler } from './service/command/advertise-rental-object-command-handler.service';
import { FeeChangeService } from './service/data/fee-change.service';
import { FeeChangeCommandHandler } from './service/command/fee-change-command-handler.service';
import { OtherRentalObjectManagerComponent } from './component/other-rental-object-manager/other-rental-object-manager.component';
import { LeaseAgreementExportNoPersonalDataCommandHandler } from './service/command/lease-agreement-export-no-personal-data-command-handler.service';
import { CompanyVismaConfigComponent } from './component/company-visma-config/company-visma-config.component';
import { CompanyHogiaConfigComponent } from './component/company-hogia-config/company-hogia-config.component';
import { CopyRoomsCommandHandler } from './service/command/copy-rooms-command-handler.service';
import { CopyRoomsFormComponent } from './component/copy-rooms-form/copy-rooms-form.component';
import { PrintStairCaseListCommandHandler } from './service/command/print-staircaselist-command-handler';
import { PrintBrokerInformationCommandHandler } from './service/command/print-broker-information-command-handler.service';
import {
  PropertyBaseSearchService,
  PropertySearchService,
  RentalObjectSearchService,
} from '../common/service/data/property-base-search.service';
import { ESignKeyRecieptDocumentComponent } from './component/esign-key-reciept-document/esign-key-reciept-document.component';
import { CooperativeHousingContractService } from './service/data/cooperative-housing-contract.service';
import { CooperativeHousingContractManagerComponent } from './component/cooperative-housing-contract-manager/cooperative-housing-contract-manager.component';
import { CooperativeHousingContractFormComponent } from './component/cooperative-housing-contract-form/cooperative-housing-contract-form.component';
import { BrfTransferComponent } from './component/brf-transfer/brf-transfer.component';
import { CompanyBankAccountsComponent } from './component/company-bank-account/company-bank-accounts.component';
import { ChangeDocumentVisibilityComponent } from './component/change-document-visibility/change-document-visibility.component';
import { FortnoxComponent } from './component/fortnox/fortnox.component';
import { LeaseAgreementLogService } from './service/data/lease-agreement-log.service';
import { SetLettingFeaturesFormComponent } from './component/set-letting-features-form/set-letting-features-form.component';
import { SetLettingFeaturesCommandHandler } from './service/command/set-letting-features-command-handler.service';
import { LettingFeatureService } from './service/data/letting-feature.service';
import { LettingFeatureColumnComponent } from './component/letting-feature-column/letting-feature-column.component';
import { CooperativeHousingTransferService } from './service/data/cooperative-housing-transfer.service';
import { CooperativeHousingTransferFormComponent } from './component/cooperative-housing-transfer-form/cooperative-housing-transfer-form.component';
import { CooperativeHousingTransferFormService } from './service/data/cooperative-housing-transfer-form.service';
import { ContactLogService } from './service/data/contact-log.service';
import { CompanyLogService } from './service/data/company-log.service';
import { ControlDataExportListService } from './service/data/control-data-export.service';
import { ControlDatExportManagerComponent } from './component/control-data-export-manager/control-data-export-manager.component';
import { ControlDataExportFormComponent } from './component/control-data-export-form/control-data-export-form.component';
import { ControlDataExportFormService } from './service/data/control-data-export-form.service';
import { ControlDataFormService } from './service/data/control-data-form.service';
import { ControlData55FormComponent } from './component/control-data-55-form/control-data-55-form.component';
import { RentalObjectLogService } from './service/data/rental-object-log.service';
import { SendToHomeQCommandHandler } from './service/command/send-to-homeq-command-handler.service';
import { CreateBuildingSpaceDialogComponent } from './component/create-building-space-dialog/create-building-space-dialog.component';
import { BuildingSpaceService } from './service/data/building-space.service';
import { EditBuildingSpaceDialogComponent } from './component/edit-building-space-dialog/edit-building-space-dialog.component';
import { ContactDocumentService } from './service/data/contact-document.service';
import { ContactDocumentFormComponent } from './component/contact-document-form/contact-document-form.component';
import { BuildingSpaceTypeService } from './service/data/building-space-type.service';
import { BuildingSpaceTypeManagerComponent } from './component/building-space-type-manager/building-space-type-manager.component';
import { BuildingSpaceTypeFormComponent } from './component/building-space-type-form/building-space-type-form.component';
import { LettingFeatureFormComponent } from './component/letting-feature-form/letting-feature-form.component';
import { LettingFeatureManagerComponent } from './component/letting-feature-manager/letting-feature-manager.component';
import { LettingFeatureAdminService } from './service/data/letting-feature-admin.service';
import { MoveBuildingToPropertyDialogComponent } from './component/move-building-to-property-dialog/move-building-to-property-dialog.component';
import { MovePropertyToCompanyDialogComponent } from './component/move-property-to-company-dialog/move-property-to-company-dialog.component';
import { MoveToPropertyCommandHandler } from './service/command/move-to-property-command-handler.service';
import { ChangeRentalObjectCategoryCommandHandler } from './service/command/change-rental-object-category-command-handler.service';
import { ChangeRentalObjectCategoryDialogComponent } from './component/change-rental-object-category-dialog/change-rental-object-category-dialog.component';
import { RentalObjectCategoryService } from './service/data/rental-object-category.service';
import { PropertyDocumentFormComponent } from './component/property-contact-form/property-document-form.component';
import { PropertyDocumentService } from './service/data/property-document-service';
import { CompanyDocumentFormComponent } from './component/company-document-form/company-document-form.component';
import { CompanyDocumentService } from './service/data/company-document.service';
import { CompanyDocumentComponent } from './component/company-document/company-document.component';
import { ContactExportCommandHandler } from './service/command/contact-export-command-handler.service';
import { ContactDocumentInformationNoteComponent } from './component/information-note/contact-document-information-note.component';
import { RepresentativesFormComponent } from './component/representatives-form/representatives-form.component';
import { RepresentativesFilterTableComponent } from './component/representatives-filter-table/representatives-filter-table.component';
import { RepresentativeService } from './service/data/representative.service';
import { RepresentativeTableCheckboxComponent } from './component/representative-table-checkbox/representative-table-checkbox.component';
import { RepresentativeDeleteDialogComponent } from './component/representative-delete-dialog/representative-delete-dialog.component';
import { RepresentativeRowsComponent } from './component/representative-rows/representative-rows.component';
import { SendRegistrationKeyCommandHandler } from './service/command/send-registration-key-command-handler.service';
import { LettingFeaturesFormComponent } from './component/letting-features-form/letting-features-form.component';
import { CompanyBankAccountComponent } from './component/company-bank-account-group/company-bank-account.component';
import { CompanyAccountPlanChangeComponent } from './component/company-account-plan-change/company-account-plan-change.component';
import { PlannedMaintenanceActionComponent } from './component/planned-maintenance-action/planned-maintenance-action.component';
import { PropertyDocumentInformationNoteComponent } from './component/information-note/property-document-information-note.component';
import { SendRegistrationKeyFormRepresentativeComponent } from './component/send-registration-key-form-representative/send-registration-key-form-representative.component';
import { SendRegistrationKeyRepresentativeCommandHandler } from './service/command/send-registration-key-representative-command-handler.service';
import { RepresentativeManagerComponent } from './component/representative-manager/representative-manager.component';
import { MoveBalanceFormComponent } from './component/move-balance-form/move-balance-form';
import { MoveBalanceCommandHandler } from './service/command/move-balance-command-handler.service';
import { ControlDataFormListComponent } from './component/control-data-form-list/control-data-form-list.component';
import { PrintControlDataCommandHandler } from '../accounting/service/command/print-control-data-command-handler.service';
import { ControlDataFormCommandHandlerResolver } from '../accounting/service/command/control-data-export-file-command-handler-resolver.service';
import { ControlDataExportFileService } from './service/data/control-data-export-file.service';
import { RegenerateControlDataCommandHandler } from '../accounting/service/command/regenerate-control-data-command-handler.service';
import { GenerateNewControlDataFileCommandHandler } from './service/command/generate-new-control-data-file-command-handler.service';
import { ControlDataRegenerateFormComponent } from './component/control-data-regenerate-form/control-data-regenerate-form.component';
import { SetLockDateComponent } from './component/set-lock-date/set-lock-date.component';
import { BuildingDocumentsComponent } from './component/building-documents/building-documents.component';
import { LeaseAgreementImdConsumptionService } from './service/data/lease-agreement-imd-consumption.service';
import { ChangePropertyDocumentVisibilityComponent } from './component/change-property-document-visibility/change-property-document-visibility.component';
import { VacantOtherExportCommandHandler } from './service/command/vacant-other-export-command-handler.service';
import { FeeChangeManagerComponent } from './component/fee-change-manager/fee-change-manager.component';
import { FeeChangeFormComponent } from './component/fee-change.form/fee-change-form.component';
import { FeeChangeAddFormComponent } from './component/fee-change-add-form/fee-change-add-form.component';
import { FeeChangeRevertCommandHandler } from './service/command/fee-change-revert-command-handler.service';
import { RentalObjectKeyManagerComponent } from './component/rental-object-key-manager/rental-objekt-key-manager.component';
import { RentalObjectKeyService } from './service/data/rental-object-key.service';
import { RentalObjectKeyFormComponent } from './component/rental-object-key/rental-object-key-form.component';
import { RentalObjectKeyHandoverService } from './service/data/rental-object-key-handover.service';
import { RentalObjectKeyHandoverFormComponent } from './component/rental-object-key-handover-form/rental-object-key-handover-form.component';
import { EsignRentalObjectKeysComponent } from './component/esign-rental-object-keys/esign-rental-object-keys.component';
import { RentalObjectFundTransactionsComponent } from './component/rental-object-fund-transactions/rental-object-fund-transactions.component';
import { AccountPlanDimensionsService } from '../accounting/service/data/account-plan-dimensions.service';
import { SetHomeqOfficesFormComponent } from './component/set-homeq-offices-form/set-homeq-offices-form.component';
import { SendToHomeqFormComponent } from './component/send-to-homeq-form/send-to-homeq-form.component';
import { ComponentSendToHomeqDispatcher } from './service/command/component-send-to-homeq-dispatcher.service';
import { UpdateTransferCommandHandler } from '../accounting/service/command/update-transfer-command-handler.service';
import { CooperativeHousingTransferManagerComponent } from './component/cooperative-housing-transfer-manager/cooperative-housing-transfer-manager.component';
import { CooperativeHousingTransferFormCommandHandlerResolver } from './service/command/cooperative-housing-transfer-form-command-handler-resolver.service';
import { CooperativeHousingTransferCommandHandlerResolver } from './service/command/cooperative-housing-transfer-command-handler-resolver.service';
import { CooperativeHousingTransferUpdateFormComponent } from './component/cooperative-housing-transfer-update-form/cooperative-housing-transfer-update-form.component';
import { AddBankTransactionImportDateFormComponent } from './component/add-bank-transaction-import-date-form/add-bank-transaction-import-date-form.component';
import { TransferListComponent } from './component/transfer-list/transfer-list.component';
import { BrfPreTransferComponent } from './component/brf-pre-transfer/brf-pre-transfer.component';
import { CompanySieConfigComponent } from './component/company-sie-config/company-sie-config.component';
import { CompanyGl07ConfigComponent } from './component/company-gl07-config/company-gl07-config.component';
import { CompanyRaindanceConfigComponent } from './component/company-raindance-config/company-raindance-config.component';
import { RentalObjectMortgagePrescriptionsComponent } from './component/rental-object-mortgage-prescriptions/rental-object-mortgage-prescriptions.component';
import { CustomPropertyHelper } from './helper/customproperties-helper';
import { LettingFeatureFilterHelper } from './helper/letting-feature-filter-helper';
import { LettingFeatureColumnHelper } from './helper/letting-feature-column-helper';
import { ComponentService } from './service/data/component.service.';
import { RoomOrderSidebarComponent } from './component/room-order-sidebar/room-order-sidebar.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PropertyTaxComponent } from './component/property-tax-form/property-tax-form.component';
import { BuildingPropertyTaxAssessmentComponent } from './component/building-property-tax-assessment/building-property-tax-assessment.component';
import { PropertyTaxService } from './service/data/property-tax-service';
import { BuildingPropertyTaxAssessmentService } from './service/data/building-property-tax-assessment.service';
import { RentInvoicingOrderManagerComponent } from './component/rent-invoicing-order-manager/rent-invoicing-order-manager.component';
import { RentInvoicingOrderFormComponent } from './component/rent-invoicing-order-form/rent-invoicing-order-form.component';
import { CreateLeaseAgreementInvoicesComponent } from './component/create-lease-agreement-invoices/create-lease-agreement-invoices.component';
import { RentInvoicingOrderDetailsService } from './service/data/rent-invoicing/rent-invoicing-order-details.service';
import { RentInvoicingOrderInvoiceService } from './service/data/rent-invoicing/rent-invoicing-order-invoice.service';
import { RentInvoicingOrderService } from './service/data/rent-invoicing/rent-invoicing-order.service';
import { RentInvoicingOrderSingleLeaseService } from './service/data/rent-invoicing/rent-invoicing-order-single-lease-service';
import { BrfMortgagePrescriptionManagerComponent } from './component/brf-mortgage-prescription-manager/brf-mortgage-prescription-manager.component';
import { BrfMortgagePrescriptionService } from './service/data/brf-mortgage-prescription.service';
import { PropertyFormCommandHandler } from './service/command/property-form-command-handler.service';
import { PropertyTaxRentalCommandHandler } from './service/command/property-tax-rental-command-handler.service';
import { PropertyTaxRentalChangesComponent } from './component/property-tax-rental-manager/property-tax-rental-changes.component';
import { PropertyTaxFeeChangeService } from './service/data/property-tax-fee-change.service';

@NgModule({
  imports: [CommonModule, ConsumptionModule, CoreModule, InvoiceModule, OverviewModule, DragDropModule],
  declarations: [
    SetLockDateComponent,
    BlockLeaseRowsComponent,
    BuildingFormComponent,
    BuildingManagerComponent,
    CompanyFormComponent,
    CompanyManagerComponent,
    CompanySystemSettingsBulkComponent,
    ControlDatExportManagerComponent,
    ControlDataExportFormComponent,
    ControlData55FormComponent,
    CooperativeHousingTransferFormComponent,
    CooperativeHousingTransferManagerComponent,
    CopyRoomsFormComponent,
    CreateBuildingSpaceDialogComponent,
    EditBuildingSpaceDialogComponent,
    SetLettingFeaturesFormComponent,
    DwellingRentalObjectManagerComponent,
    DwellingFormComponent,
    MoveBuildingToPropertyDialogComponent,
    ChangeRentalObjectCategoryDialogComponent,
    OtherRentalObjectFormComponent,
    OtherRentalObjectManagerComponent,
    ParkingRentalObjectManagerComponent,
    ParkingFormComponent,
    ParkingContractManagerComponent,
    ParkingContractFormComponent,
    PropertyFormComponent,
    PropertyErrandTagResponsibilityComponent,
    PremisesRentalObjectManagerComponent,
    PremisesFormComponent,
    PropertyManagerComponent,
    CooperativeHousingContractFormComponent,
    CooperativeHousingContractManagerComponent,
    BrfTransferComponent,
    BrfPreTransferComponent,
    BrfMortgagePrescriptionManagerComponent,
    DwellingContractManagerComponent,
    DwellingContractFormComponent,
    EsignatureErrandManagerComponent,
    EsignRentalObjectKeysComponent,
    CompanyFortnoxConfigComponent,
    CompanySieConfigComponent,
    CompanyGl07ConfigComponent,
    CompanyRaindanceConfigComponent,
    CompanyVismaConfigComponent,
    CompanyHogiaConfigComponent,
    ContactFormComponent,
    ContactManagerComponent,
    CustomPropertyFormComponent,
    CustomPropertyManagerComponent,
    ObjectComponentCategoryFormComponent,
    ObjectComponentCategoryManagerComponent,
    RentalObjectKeyFormComponent,
    RentalObjectKeyHandoverFormComponent,
    RentalObjectTypeFormComponent,
    RentalObjectTypeManagerComponent,
    TenantAutocompleteComponent,
    TransferListComponent,
    KeyTypeFormComponent,
    KeyTypeManagerComponent,
    LeaseRowsComponent,
    RepayBalanceFormComponent,
    SubleaseRequestsComponent,
    SubleaseRequestFormComponent,
    LeaseRowFormComponent,
    AppendixManagerComponent,
    AppendixFormComponent,
    IndexClauseSettingsManagerComponent,
    IndexClauseSettingsFormComponent,
    ArticleGroupMultiSelectManagerComponent,
    ArticleMultiSelectManagerComponent,
    ArticleFormComponent,
    ArticleGroupFormComponent,
    ArticleAutocompleteComponent,
    OtherContractManagerComponent,
    OtherContractFormComponent,
    BlockContractFormComponent,
    BlockContractManagerComponent,
    BuildingDocumentFormComponent,
    BuildingDocumentManagerComponent,
    BuildingDocumentsComponent,
    BuildingSpaceTypeManagerComponent,
    BuildingSpaceTypeFormComponent,
    LettingFeatureFormComponent,
    LettingFeatureManagerComponent,
    FeeChangeFormComponent,
    FeeChangeManagerComponent,
    FeeChangeAddFormComponent,
    PremisesContractFormComponent,
    PremisesContractManagerComponent,
    RentalObjectKeysComponent,
    RentalObjectFundTransactionsComponent,
    RentalObjectMortgagePrescriptionsComponent,
    RentApplicationFormComponent,
    RentApplicationManagerComponent,
    VacantPeriodAutocompleteComponent,
    VacantPeriodCooperativeHousingAutocompleteComponent,
    NoticePeriodComponent,
    VacantDwellingComponent,
    VacantPeriodDwellingManagerComponent,
    VacantPeriodOtherManagerComponent,
    VacantPeriodParkingManagerComponent,
    VacantPeriodPremisesManagerComponent,
    VacantParkingComponent,
    VacantPremisesComponent,
    VacantOtherRentalObjectComponent,
    SendRegistrationKeyFormComponent,
    SendRegistrationKeyFormRepresentativeComponent,
    NegotiationComponent,
    RentalChangesComponent,
    PropertyTaxRentalChangesComponent,
    TerminateLeaseAgreementComponent,
    ESignKeyRecieptDocumentComponent,
    ESignLeaseAgreementDocumentComponent,
    VoidLeaseAgreementComponent,
    VoidCooperativeHousingLeaseAgreementComponent,
    RentalObjectImprovementsComponent,
    RentalObjectImprovemntsFormComponent,
    ContractInvoicingComponent,
    ContractSecurityComponent,
    BankAccountComponent,
    CompanyBankAccountComponent,
    CompanyBankAccountsComponent,
    CompanyAccountPlanChangeComponent,
    LeaseAgreementDocumentManagerComponent,
    RentalObjectDocumentManagerComponent,
    RentalObjectKeyManagerComponent,
    RentInvoicingOrderManagerComponent,
    RentInvoicingOrderFormComponent,
    CreateLeaseAgreementInvoicesComponent,
    LeaseAgreementDocumentFormComponent,
    BrokerInformationFormComponent,
    ControlDataRegenerateFormComponent,
    CooperativeHousingTransferUpdateFormComponent,
    RentalObjectDocumentFormComponent,
    LeaseAgreementRentPeriodManagerComponent,
    ESignatureErrandFormComponent,
    FormCasesFastighetsagarnaDokumentComponent,
    RoomsComponent,
    RoomOrderSidebarComponent,
    RoomFormComponent,
    ObjectComponentComponent,
    ObjectComponentPropertiesComponent,
    ChangeDocumentVisibilityComponent,
    ChangePropertyDocumentVisibilityComponent,
    FortnoxComponent,
    ContactDocumentFormComponent,
    MoveBalanceFormComponent,
    CompanyDocumentFormComponent,
    PropertyDocumentFormComponent,
    CompanyDocumentComponent,
    ContactDocumentInformationNoteComponent,
    RepresentativesFormComponent,
    RepresentativesFilterTableComponent,
    RepresentativeTableCheckboxComponent,
    RepresentativeDeleteDialogComponent,
    RepresentativeRowsComponent,
    LettingFeaturesFormComponent,
    LettingFeatureColumnComponent,
    PropertyDocumentInformationNoteComponent,
    PlannedMaintenanceActionComponent,
    RepresentativeManagerComponent,
    ControlDataFormListComponent,
    SetHomeqOfficesFormComponent,
    SendToHomeqFormComponent,
    AddBankTransactionImportDateFormComponent,
    MovePropertyToCompanyDialogComponent,
    PropertyTaxComponent,
    BuildingPropertyTaxAssessmentComponent,
  ],
  providers: [
    AccountPlanService,
    AdvertiseRentalObjectCommandHandler,
    AppendixService,
    IndexClauseSettingsService,
    ArticleExportCommandHandler,
    ArticleGroupService,
    ArticleService,
    BuildingDocumentService,
    BuildingService,
    BuildingSpaceService,
    BuildingSpaceTypeService,
    LettingFeatureAdminService,
    BlockContractService,
    CleanupTenantCommandHandler,
    ColumnDefinitionService,
    CompanyService,
    CompanyLogService,
    CompanyDocumentService,
    ContactDocumentService,
    ContactLogService,
    ContactService,
    PrintControlDataCommandHandler,
    UpdateTransferCommandHandler,
    RegenerateControlDataCommandHandler,
    BrfMortgagePrescriptionService,
    ControlDataFormCommandHandlerResolver,
    ControlDataExportFileService,
    CooperativeHousingTransferService,
    ControlDataExportFormService,
    ControlDataExportListService,
    ControlDataFormService,
    CopyRoomsCommandHandler,
    CreateBlockContractRentalObjectCommandHandler,
    CreateInvoiceCommandHandler,
    CustomPropertyService,
    CooperativeHousingContractService,
    CooperativeHousingTransferFormService,
    CooperativeHousingTransferCommandHandlerResolver,
    CooperativeHousingTransferFormCommandHandlerResolver,
    DwellingContractService,
    DwellingService,
    EntranceService,
    EsignatureErrandService,
    FaultNotificationService,
    FeeChangeCommandHandler,
    FeeChangeService,
    KeyTypeService,
    LeaseAgreementDocumentService,
    RentInvoicingOrderDetailsService,
    RentInvoicingOrderService,
    RentInvoicingOrderSingleLeaseService,
    RentInvoicingOrderInvoiceService,
    RentalObjectDocumentService,
    PropertyBaseSearchService,
    RentalObjectKeyService,
    RentalObjectKeyHandoverService,
    RentalObjectSearchService,
    PropertySearchService,
    LeaseAgreementExportCommandHandler,
    LeaseAgreementExportNoPersonalDataCommandHandler,
    LettingFeatureService,
    LinkBuildingDocumentCommandHandler,
    LinkLeaseAgreementDocumentCommandHandler,
    LinkRentalObjectDocumentCommandHandler,
    DwellingExportCommandHandler,
    ParkingExportCommandHandler,
    PremisesExportCommandHandler,
    MoveToCompanyCommandHandler,
    LeaseAgreementLogService,
    LeaseAgreementImdConsumptionService,
    LeaseAgreementService,
    MoveBalanceCommandHandler,
    MoveToPropertyCommandHandler,
    ChangeRentalObjectCategoryCommandHandler,
    ObjectComponentCategoryService,
    ObjectComponentService,
    ObjectComponentTypeService,
    OtherContractService,
    OtherRentalObjectService,
    ParkingContractService,
    ParkingService,
    PremisesContractService,
    PremisesService,
    PrintBrokerInformationCommandHandler,
    PrintContractTerminationFormCommandHandler,
    PrintParkingContractFormCommandHandler,
    PrintStairCaseListCommandHandler,
    PropertyDocumentService,
    PropertyService,
    GenerateNewControlDataFileCommandHandler,
    FeeChangeRevertCommandHandler,
    RentalObjectLogService,
    RentalObjectTypeService,
    RentalObjectCategoryService,
    RentApplicationExportCommandHandler,
    RentApplicationService,
    RepayBalanceCommandHandler,
    RepresentativeService,
    RoomService,
    ComponentService,
    SendToHomeQCommandHandler,
    SetLettingFeaturesCommandHandler,
    ShowBuildingDocumentsCommandHandler,
    ShowDocumentsCommandHandler,
    ShowRentalObjectDocumentsCommandHandler,
    ShowInvoicesCommandHandler,
    ShowFaultNotificationCommandHandler,
    ShowRentalObjectInvoicesCommandHandler,
    TenantService,
    VacantRentalObjectService,
    VacantDwellingService,
    VacantParkingService,
    VacantPremisesService,
    VacantOtherService,
    VacantDwellingExportCommandHandler,
    VacantPremisesExportCommandHandler,
    VacantParkingExportCommandHandler,
    VacantOtherExportCommandHandler,
    OpenESignatureDocumentCommandHandler,
    CancelESignErrandCommandHandler,
    ContactExportCommandHandler,
    SendRegistrationKeyCommandHandler,
    SendRegistrationKeyRepresentativeCommandHandler,
    AccountPlanDimensionsService,
    ComponentSendToHomeqDispatcher,
    MoveToCompanyCommandHandler,
    PropertyFormCommandHandler,
    CustomPropertyHelper,
    LettingFeatureFilterHelper,
    LettingFeatureColumnHelper,
    PropertyTaxService,
    PropertyTaxFeeChangeService,
    BuildingPropertyTaxAssessmentService,
    PropertyTaxRentalCommandHandler,
  ],
})
export class RentModule {}
